import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

declare global {
  interface Window {
    __phindiMapsReady?: () => void;
  }
}

/**
 * Carga perezosa de la Maps JavaScript API (FE-00/FE-02).
 *
 * La key se configura en `environment.googleMapsApiKey`. Si falta, el
 * componente de mapa muestra un aviso en lugar de romper la pantalla.
 */
@Injectable({ providedIn: 'root' })
export class GoogleMapsLoader {
  private carga?: Promise<void>;

  /** true si hay API key configurada. */
  get disponible(): boolean {
    return !!environment.googleMapsApiKey;
  }

  load(): Promise<void> {
    if (!this.disponible) {
      return Promise.reject(
        new Error('Falta configurar googleMapsApiKey en environment.ts'),
      );
    }
    this.carga ??= new Promise<void>((resolve, reject) => {
      window.__phindiMapsReady = () => resolve();
      const script = document.createElement('script');
      const params = new URLSearchParams({
        key: environment.googleMapsApiKey,
        v: 'weekly',
        libraries: 'marker',
        language: 'es-419',
        region: 'AR',
        loading: 'async',
        callback: '__phindiMapsReady',
      });
      script.src = `https://maps.googleapis.com/maps/api/js?${params}`;
      script.async = true;
      script.onerror = () =>
        reject(new Error('No se pudo cargar Google Maps'));
      document.head.appendChild(script);
    });
    return this.carga;
  }
}
